import * as types from '@store/types'
import axios from 'axios'

const state = {
  notice: {},
  path: null
}

const getters = {
  [types.NOTICE]: (state) => state.notice,
  [types.NOTICE_CLICK]: (state) => state.path
}

const mutations = {
  [types.NOTICE]: (state, payload) => {
    state.notice = { ...payload.data }
  },
  [types.NOTICE_CLICK]: (state, payload) => {
    state.path = { ...payload.data }
  }
}
const actions = {
  [types.NOTICE]: async ({ commit }) => {
    try {
      const url = 'notice/last'
      const response = await axios.get(url)

      commit(types.NOTICE, response.data)
    } catch (e) {
      return e
    }
  },
  [types.NOTICE_CLICK]: async ({ commit }, payload) => {
    try {
      const notice = payload.id
      const url = `notice/${notice}/link`
      const response = await axios.get(url)
      commit(types.NOTICE_CLICK, response)
      return response
    } catch (e) {
      return e
    }
  }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/notices.js